module.exports = __webpack_public_path__ + "img/title_txt_day3.90c12c70.png";